import { useCallback, useState } from 'react';

import type { Picture } from 'app/typings';

export const useImagePreview = () => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const showPreview = useCallback((picture: Picture) => {
    setPreviewTitle(picture.name);
    setPreviewImage(picture.pictureId);
    setPreviewVisible(true);
  }, []);

  const closePreview = useCallback(() => {
    setPreviewVisible(false);
    setPreviewTitle('');
    setPreviewImage('');
  }, []);

  return {
    previewVisible,
    previewImage,
    previewTitle,
    showPreview,
    closePreview,
  };
};
